module.exports = __webpack_public_path__ + "static/media/cq_home.4d6c5ac7.svg";